// We create Redux store directly, instead of using any extra dependencies.
import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import createReducer from './reducers';
import * as analytics from './analytics/analytics';
import appSettings from './config/settings';
import { apiSlice } from './api/store/apiSlice';


/**
 * Create a new store with the given initial state. Adds Redux
 * middleware and enhancers.
 */
export default function configureStore({
  initialState = {},
  sdk = null,
  analyticsHandlers = [],
  extraMiddlewares = [],
}) {
  // returns the store
  return configureStoreReduxToolkit({
    reducer: createReducer(),
    preloadedState: initialState,
    middleware: getDefaultMiddleware => {
      const middlewares = getDefaultMiddleware({
        thunk: {
          extraArgument: sdk,
        },
        // Note: we do save class-based objects like UUIDs, Money, LatLng, LatLngBounds, Dates and Decimals to the store
        serializableCheck: false,
      })
        .concat(apiSlice.middleware)
        .prepend(analytics.createAnalyticsListenerMiddleware(analyticsHandlers).middleware);

      return middlewares.concat(extraMiddlewares);
    },
    devTools: appSettings.dev && typeof window === 'object',
  });
}
